import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { MenuIcon, XIcon } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

export function Header() {
  const location = useLocation()
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  const isActive = (path: string) => {
    return location.pathname === path
      ? 'text-primary font-semibold'
      : 'text-gray-600 hover:text-primary'
  }

  const closeMenu = () => setIsMobileMenuOpen(false)

  return (
    <header className="sticky top-0 z-50 w-full bg-white/90 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20 md:hidden">
          <div className="flex-none flex justify-start w-12">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2 -ml-2 text-gray-600 hover:text-primary transition-colors focus:outline-none"
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" /> : <MenuIcon className="w-6 h-6" />}
            </button>
          </div>
          <div className="flex-1 flex justify-center px-4">
            <Link to="/" className="flex items-center w-full justify-center" onClick={closeMenu}>
              <img
                src="/images/lettrage_2.svg"
                alt="greenmango"
                className="w-[70%] h-auto max-w-[250px]"
              />
            </Link>
          </div>
          <div className="flex-none w-12" />
        </div>

        <div className="hidden md:flex items-center justify-between h-20">
          <Link to="/" className="flex items-center">
            <img
              src="/images/lettrage_2.svg"
              alt="greenmango"
              className="h-8 w-auto"
            />
          </Link>

          <nav className="flex items-center gap-8">
            <Link
              to="/product-building"
              className={`transition-colors text-sm font-medium font-['Poppins'] ${isActive('/product-building')}`}
            >
              Product building
            </Link>
            <Link
              to="/consulting"
              className={`transition-colors text-sm font-medium font-['Poppins'] ${isActive('/consulting')}`}
            >
              Consulting
            </Link>
            <Link
              to="/training"
              className={`transition-colors text-sm font-medium font-['Poppins'] ${isActive('/training')}`}
            >
              Training
            </Link>
            <Link
              to="/blog"
              className={`transition-colors text-sm font-medium font-['Poppins'] ${isActive('/blog')}`}
            >
              Blog
            </Link>

            {/* Language switcher — temporarily disabled. Re-enable when i18n is implemented (see TRANSLATION.md) */}
            {/* <div className="flex items-center gap-2 ml-4 border-l border-gray-200 pl-6">
              <button className="text-xs font-bold bg-primary text-white px-2 py-1 rounded transition-colors">
                EN
              </button>
              <button className="text-xs font-bold text-gray-500 hover:text-gray-900 hover:bg-gray-100 px-2 py-1 rounded border border-gray-200 transition-colors">
                FR
              </button>
            </div> */}

            <Link
              to="/contact"
              className="ml-2 inline-flex items-center justify-center px-5 py-2 text-sm font-medium rounded-lg text-white bg-primary hover:bg-primary-dark transition-colors shadow-sm font-['Poppins']"
            >
              Contact
            </Link>
          </nav>
        </div>
      </div>

      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            className="md:hidden bg-white border-b border-gray-200 overflow-hidden"
          >
            <nav className="flex flex-col px-4 pt-2 pb-6 space-y-4">
              <Link
                to="/product-building"
                onClick={closeMenu}
                className={`block py-2 transition-colors text-base font-medium font-['Poppins'] ${isActive('/product-building')}`}
              >
                Product building
              </Link>
              <Link
                to="/consulting"
                onClick={closeMenu}
                className={`block py-2 transition-colors text-base font-medium font-['Poppins'] ${isActive('/consulting')}`}
              >
                Consulting
              </Link>
              <Link
                to="/training"
                onClick={closeMenu}
                className={`block py-2 transition-colors text-base font-medium font-['Poppins'] ${isActive('/training')}`}
              >
                Training
              </Link>
              <Link
                to="/blog"
                onClick={closeMenu}
                className={`block py-2 transition-colors text-base font-medium font-['Poppins'] ${isActive('/blog')}`}
              >
                Blog
              </Link>

              {/* Language switcher — temporarily disabled. Re-enable when i18n is implemented (see TRANSLATION.md) */}
              {/* <div className="pt-4 mt-2 border-t border-gray-100 flex items-center gap-3">
                <button className="text-sm font-bold bg-primary text-white px-3 py-1.5 rounded transition-colors">EN</button>
                <button className="text-sm font-bold text-gray-500 hover:text-gray-900 hover:bg-gray-100 px-3 py-1.5 rounded border border-gray-200 transition-colors">FR</button>
              </div> */}

              <div className="pt-4 pb-2">
                <Link
                  to="/contact"
                  onClick={closeMenu}
                  className="flex w-full items-center justify-center px-4 py-3 text-base font-medium rounded-lg text-white bg-primary hover:bg-primary-dark transition-colors shadow-sm font-['Poppins']"
                >
                  Contact
                </Link>
              </div>
            </nav>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  )
}